import { Component, HostBinding, Inject } from '@angular/core';
import { IMODALS_SERVICE, IModalsService, P500UIBaseModal } from '@platform500services/p500-ui-kit';
import { BrowserWindowRef } from '../../services/window/window.service';
import { Router } from '@angular/router';

@Component({
  selector: 'gtd-new-version-modal',
  templateUrl: './new-version.modal.html',
})
export class NewVersionModal extends P500UIBaseModal {
  @HostBinding('class') className = 'c-modal--new-version';

  constructor(
    @Inject(IMODALS_SERVICE) public override modalsService: IModalsService,
    @Inject(BrowserWindowRef) protected window: BrowserWindowRef,
    protected override router: Router
  ) {
    super(modalsService, router);
  }

  reloadPage() {
    this.window.nativeWindow.location.reload();
  }
}
